module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.scss
// module id = ./src/app/shared/navbar/navbar.component.scss
// module chunks = main